export interface AadAppConfig {
    /**
     * The (Azure) cloud name.
     */
    cloudName: string;

    /**
     * The Azure tenant.
     */
    tenant: string;

    /**
     * The Azure tenant Id. Same as Tenant. Maintained for backwards compatiblity.
     */
    tenantId: string;

    /**
     * The client id.
     */
    clientId: string;

    /**
     * The AAD application id.
     */
    appId: string;

    /**
     * The AAD application display name.
     */
    appDisplayName: string;

    /**
     * The AAD application app verify address.
     */
    appVerifyAddress: string;
}
